import { extractLabelsWithParentInfo } from '@iot-platform/iot-platform-utils';
import { Affiliate, Filter, FilterDefaultOptions } from '@iot-platform/models/common';
import { get } from 'lodash';

const deviceAffiliate = {
  displayWrapper: (element: Filter | Affiliate | undefined) => {
    if ((element as Filter)?.value) {
      return (element as Filter).value.id + ' : ' + (element as Filter).value.name;
    } else if ((element as Affiliate)?.id) {
      return (element as Affiliate).id + ' : ' + (element as Affiliate).name;
    }
    return '';
  }
};

const deviceCommunicationOperator = {
  dataTransform: (data: any) => data.map((v: any) => ({ id: v, name: v }))
};

const tagLabelId = {
  dataTransform: (data: any) => extractLabelsWithParentInfo(data),
  displayValueWrapper: (element: any) => `${element?.parentName} - ${element?.name}`
};

const deviceTypeFirmware = {
  displayWrapper: (element: any) => {
    if (get(element, 'id')) {
      return Number(get(element, 'version'))?.toFixed(3);
    }
    return '';
  }
};

const siteTagLabelId = tagLabelId;
const assetTagLabelId = tagLabelId;
const deviceTagLabelId = tagLabelId;
const eventTagLabelId = tagLabelId;

export const COMMON_FILTERS_OPTIONS: { [key: string]: FilterDefaultOptions } = {
  siteTagLabelId,
  assetTagLabelId,
  deviceTagLabelId,
  eventTagLabelId,
  deviceAffiliate,
  deviceCommunicationOperator,
  deviceTypeFirmware,
  version: deviceTypeFirmware
};
